import { useState, Fragment, useEffect } from "react";
import MenuCatalogo from "../components/MenuCatalogo";
import Footer2 from "../components/Footer2";
// import MenuSuspension from "../components/MenuSuspension";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
// import BannerButton from "../components/BannerButton";
import Global from "../components/Global";
import { registerLicense } from "@syncfusion/ej2-base";
// import LocationBanner from "../components/LocationBanner";
import {
  CarouselComponent,
  CarouselItemsDirective,
  CarouselItemDirective,
} from "@syncfusion/ej2-react-navigations";
import CatalogueProductItem from "../components/CatalogueProductItem";
//import licenciaSyncfusion from "../components/Global";

// Banner images
import bannerAmortiguadores from "../images/GROBMX_Amortiguadores.jpg";
import bannerDireccion from "../images/GROBMX_direccion.jpg";
import bannerRodamientos from "../images/GROBMX_rodamientos.jpg";
import bannerServicioPesado from "../images/GROBMX_servicio_pesado.jpg";
import bannerSoportes from "../images/GROBMX_soportes.jpg";

registerLicense(Global.licenciaSyncfusion);

const MainPage = () => {
  const [productos, setProductos] = useState([]);
  const [status, setstatus] = useState("");
  const [actualizacionCarrito, setCarrito] = useState(0);
  //const [barActivo, setBarActivo] =   useState("descripcion");
  const [busquedaOpcion, setBusquedaOpcion] = useState(1);

  const actualizarproductos = (postProductos) => {
    setProductos(postProductos);
  };

  async function actualizaBusqueda(opcion) {
    if (opcion === undefined) {
      setBusquedaOpcion(1);
      return 1;
    } else {
      setBusquedaOpcion(opcion);
      return opcion;
    }
  }

  // const idSucursal = 1;

  async function addToCart(item, cant) {
    try {
      //console.log("agregando al carrito");
      // let cart = sessionStorage.getItem("cart") ? JSON.parse(sessionStorage.getItem("cart")) : {};
      let cart = JSON.parse(sessionStorage.getItem("cart") || "{}");
      let idProducto = item.idProducto;
      cart[idProducto] = cart[idProducto] ? cart[idProducto] : item;
      var numero = cart[idProducto].Cantidad;
      if (numero === undefined) {
        cart[idProducto].Cantidad = 0;
      }
      cart[idProducto].Cantidad += cant;
      sessionStorage.setItem("cart", JSON.stringify(cart));
      // navBarRef.current.getCartItems();
      Swal2.fire({
        title: "Producto agregado",
        text:
          "Cuenta con [" +
          cart[idProducto].Cantidad +
          "] productos [" +
          cart[idProducto].Codigo +
          "] en su Carrito de Compras.",
        icon: "success",
        confirmButtonColor: "orange",
      });
      setCarrito(actualizacionCarrito + 1);
    } catch (error) {
      Swal(
        "Error en Carrito de Compras",
        "No se pudo agregar su Producto al Carrito de Compras.",
        "error"
      );
    }
  }

  useEffect(() => {
    if (productos.length > 0) {
      setstatus("success");
    } else {
      setstatus("");
    }
  }, [productos, actualizacionCarrito, busquedaOpcion]);

  return (
    <div className="">
      <ResponsiveHeader />
      <div className="row-banner">
        <div className="container">
          <div className="search-box-glass mt-3 mb-3">
            <MenuCatalogo
              actualizarproductos={actualizarproductos}
              opcionNav={busquedaOpcion}
            />
          </div>
        </div>
      </div>

      {status === "success" && (
        <Fragment>
          <div className="container">
            <div className="row mt-3">
              <div className="col-md-3"></div>
              <div className="col-md-6 text-center">
                <h6>
                  <span className="badge badge-warning ml-1 mr-1">
                    {productos.length}
                  </span>
                  <small>
                    <strong>Producto(s) encontrado(s)</strong>
                  </small>
                </h6>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div className="row">
              {productos.map((item, index) => (
                <CatalogueProductItem item={item} key={index} index={index} />
              ))}
            </div>
          </div>
        </Fragment>
      )}

      {status !== "success" && (
        <Fragment>
          {/* Menú de categorías comentado temporalmente
          <div className="row-banner2">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-auto">
                  <MenuSuspension></MenuSuspension>
                </div>
              </div>
            </div>
          </div>
          */}
          <div className="row-negro pt-3 pb-3">
            <div className="container">
              <CarouselComponent>
                <CarouselItemsDirective>
                  <CarouselItemDirective template={() => <figure className="img-container"><img src={bannerAmortiguadores} alt="Amortiguadores" style={{height:"100%",width:"100%"}} /></figure>} />
                  <CarouselItemDirective template={() => <figure className="img-container"><img src={bannerDireccion} alt="Dirección" style={{height:"100%",width:"100%"}} /></figure>} />
                  <CarouselItemDirective template={() => <figure className="img-container"><img src={bannerRodamientos} alt="Rodamientos" style={{height:"100%",width:"100%"}} /></figure>} />
                  <CarouselItemDirective template={() => <figure className="img-container"><img src={bannerServicioPesado} alt="Servicio Pesado" style={{height:"100%",width:"100%"}} /></figure>} />
                  <CarouselItemDirective template={() => <figure className="img-container"><img src={bannerSoportes} alt="Soportes" style={{height:"100%",width:"100%"}} /></figure>} />
                </CarouselItemsDirective>
              </CarouselComponent>
            </div>
          </div>
        </Fragment>
      )}

      <Footer2></Footer2>
      {/* <FooterMainPage opcionNav={actualizaBusqueda}></FooterMainPage>  */}
    </div>
  );
};

export default MainPage;
